import { Link } from 'office-ui-fabric-react';

const AiAgentsSettingsTooltip = () => (
    <div>
        AI agents streamline data analysis, reporting, and decision-making by automating tasks and delivering intelligent insights across your projects.<br />
        Please refer to the <Link href="https://help.ppm.express/ai-agents" target="_blank">article</Link> for more details.
    </div>
);

export default AiAgentsSettingsTooltip;